import { LightboxElement } from './lightbox-reducer.state';

export enum LightboxActionType {
    SetIndex,
    ShiftIndex,
    SetElements,
}

export interface LightboxSetIndexAction {
    type: LightboxActionType.SetIndex;
    payload: number;
}

export interface LightboxShiftIndexAction {
    type: LightboxActionType.ShiftIndex;
    payload: number;
}

export interface LightboxSetSourceAction {
    type: LightboxActionType.SetElements;
    payload: LightboxElement[];
}

export type LightboxAction = LightboxSetIndexAction | LightboxSetSourceAction | LightboxShiftIndexAction;

export default LightboxActionType;
